/**
 * @generated SignedSource<<290ef081e9975c4b956ce87edba73f76>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceRolesSelector_workspaces$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"OrgUserEditAccessSelect_workspaces">;
  readonly " $fragmentType": "WorkspaceRolesSelector_workspaces";
}>;
export type WorkspaceRolesSelector_workspaces$key = ReadonlyArray<{
  readonly " $data"?: WorkspaceRolesSelector_workspaces$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRolesSelector_workspaces">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "WorkspaceRolesSelector_workspaces",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OrgUserEditAccessSelect_workspaces"
    }
  ],
  "type": "Workspace",
  "abstractKey": null
};

(node as any).hash = "7f4e776e921e4e054c9a940bfc9c551a";

export default node;
